import React, { useState, useEffect } from "react";
import { Grid, Container, Box, Typography } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import LoaderContainer from "../../components/LoaderContainer";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CustomButton from "../../components/Custom/CustomButton";
import { useAlert } from "../../components/Alert";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function LenderDetails() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [lender, setLender] = useState();
  const location = useLocation();
  const [docsRequired, setDocsRequired] = useState([]);
  let { lenderId } = useParams();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const lenderName = searchParams.get("lenderName");

  // Extracting only the ID part from lenderId
  lenderId = lenderId.split("=")[1];

  useEffect(() => {
    api
      .get(`lending/get-all-lender/?lender_id=${lenderId}`)
      .then((response) => {
        setLender(response.data[0]);
        setDocsRequired(response.data[0].required_documents);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching lenders:", error);
        setLoading(false);
      });
  }, [lenderId]);

  const infoItems = lender
    ? [
        {
          label: "Interest Rate",
          value: `${lender.interest_rate_min}% - ${lender.interest_rate_max}% P.A.`,
        },
        { label: "Loan Amount", value: `Up To Rs.${lender.loan_amount}` },
        {
          label: "Loan Tenure",
          value: `Up To ${lender.loan_tenure_months} months`,
        },
        {
          label: "Minimum Revenue Required",
          value: `${lender.minimum_revenue}`,
        },
      ]
    : [];

  const handleSendLoanRequest = (lender_id, lender_onboard) => {
    if (lenderId && lender_onboard) {
      api
        .post("lending/add-loan-request/", {
          lender_id: lender_id,
          lender_onboard: lender_onboard,
        })
        .then((res) => {
          if (res && res.data) {
            showAlert("success", `${res.data.message}`);
            navigate("/fpo/loans");
          } else {
            showAlert("error", "Error Occured");
          }
        })
        .catch((err) => {
          console.log("error", err);
          showAlert("error", `${err.response.data.message}`);
        });
    }
  };
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          <Grid container style={{ marginTop: "10px" }}>
            <CustomTitle>{lenderName}</CustomTitle>

            {lender && (
              <>
                <div
                  style={{
                    height: "76vh",
                    width: "100%",
                    marginTop: "20px",
                    overflowY: "scroll",
                  }}
                >
                  {/* <img src={lender.lender_logo} height="auto" width="200" /> */}
                  <img
                    src={lender.lender_logo}
                    alt="Lender Logo"
                    style={{
                      width: "100%",
                      height: "40%",
                      objectFit: "contain",
                    }}
                  />

                  <Box sx={{ marginTop: "15%" }}>
                    {infoItems.map((item, index) => (
                      <Grid container spacing={1} key={index}>
                        <Grid item xs={6}>
                          <Typography variant="body1" fontWeight="bold">
                            {item.label}:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body1">{item.value}</Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </Box>

                  <Box sx={{ marginTop: "10%" }}>
                    <Typography variant="body1" fontWeight="bold">
                      {t("Documents Required")}
                    </Typography>
                    <ul>
                      {docsRequired.map((item) => (
                        <li key={item.name}>
                          <Typography variant="body1" fontWeight="bold">
                            {item.name}
                          </Typography>
                        </li>
                      ))}
                    </ul>
                  </Box>
                </div>

                <CustomButton
                  onClick={() =>
                    handleSendLoanRequest(lender.lender, lender.id)
                  }
                >
                  {t("Send Loan Request")}
                </CustomButton>
              </>
            )}
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}
